import { DEFAULT_COUNTRY_CODE } from '../constants/i18n'

export const useSharedCountryCode = () =>
  useState<string>('sharedCountryCode', () => DEFAULT_COUNTRY_CODE)
